import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Toolbar } from 'primereact/toolbar';
import { Dialog } from 'primereact/dialog';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ModelOfProductBrand } from 'src/database';
import LoadingScreen from '../../components/LoadingScreen';
import { useListProductBrandsController } from '../../controllers/ProductBrands/ListProductBrandsController';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import classNames from 'classnames';

const ProductBrandsList: React.FC = () => {
	const [globalFilter, setGlobalFilter] = useState<string | null>(null);
	const { getProductBrandListController, handleProductBrandListController } = useListProductBrandsController();

	if (getProductBrandListController.loading) {
		return <LoadingScreen />;
	}

	const tableHeader = (
		<div className='table-header p-grid p-d-flex p-jc-between'>
			<h5 className='p-m-0'>Marcas de Produto</h5>
			<span className='p-input-icon-left p-search-bar'>
				<i className='pi pi-search' />
				<InputText
					type='search'
					onChange={(e: React.ChangeEvent<HTMLInputElement>) => setGlobalFilter(e.target.value)}
					placeholder='Buscar...'
				/>
			</span>
		</div>
	);

	const actionBodyTemplate = (Productbrand: ModelOfProductBrand) => {
		return (
			<React.Fragment>
				<Button
					icon='pi pi-pencil'
					className='p-button-rounded p-button-text p-button-success p-mr-2'
					onClick={() => handleProductBrandListController.openEditDialog(Productbrand)}
				/>
				<Button
					icon='pi pi-trash'
					className='p-button-rounded p-button-text p-button-danger'
					onClick={() => handleProductBrandListController.openDeleteDialog(Productbrand)}
				/>
			</React.Fragment>
		);
	};

	const editProductBrandDialogFooter = (
		<React.Fragment>
			<Button
				label='Cancelar'
				icon='pi pi-times'
				className='p-button-text'
				onClick={handleProductBrandListController.closeEditDialog}
			/>
			<Button
				type='submit'
				label='Salvar'
				icon='pi pi-check'
				className='p-button-text'
				onClick={() => {
					getProductBrandListController.formik.handleSubmit();
				}}
			/>
		</React.Fragment>
	);

	const deleteProductBrandDialogFooter = (
		<React.Fragment>
			<Button
				label='Não'
				icon='pi pi-times'
				className='p-button-text'
				onClick={handleProductBrandListController.closeDeleteDialog}
			/>
			<Button
				label='Sim'
				icon='pi pi-check'
				className='p-button-text'
				onClick={() => {
					getProductBrandListController.selectedProductBrand &&
						handleProductBrandListController.removeProductBrand(
							getProductBrandListController.selectedProductBrand,
						);
				}}
			/>
		</React.Fragment>
	);

	const leftProductBrandToolbar = () => {
		return (
			<Link to='/ProductbrandForm'>
				<Button label='Cadastrar marca' icon='pi pi-plus' className='p-button-success p-mr-2' />
			</Link>
		);
	};

	return (
		<div>
			<Toast ref={getProductBrandListController.toast} />
			<div className='p-card p-p-4 datatable-container'>
				<Toolbar className='p-mb-4' left={leftProductBrandToolbar}></Toolbar>

				<DataTable
					className='p-datatable-sm'
					header={tableHeader}
					globalFilter={globalFilter}
					dataKey='ID'
					rowHover
					scrollable
					scrollHeight="70vh"
					value={getProductBrandListController.ProductBrandData}>
					<Column field='DESCRICAO' header='MARCA'></Column>
					<Column body={actionBodyTemplate} bodyStyle={{ textAlign: 'right' }}></Column>
				</DataTable>
			</div>

			<Dialog
				className='p-fluid'
				style={{ width: '450px' }}
				visible={getProductBrandListController.editDialog}
				onHide={handleProductBrandListController.closeEditDialog}
				onShow={() =>
					getProductBrandListController.formik.setFieldValue(
						'DESCRICAO',
						getProductBrandListController.selectedProductBrand?.DESCRICAO,
					)
				}
				footer={editProductBrandDialogFooter}
				header={`Editar marca ${getProductBrandListController.selectedProductBrand?.DESCRICAO}`}
				modal>
				<div className='p-field'>
					<label htmlFor='description'>Nome</label>
					<InputText
						id='name'
						type='text'
						value={getProductBrandListController.formik.values.DESCRICAO}
						onChange={getProductBrandListController.formik.handleChange('DESCRICAO')}
						required
					/>
					<div
						className={classNames('p-invalid popup-fade', {
							'popup-form-active':
								getProductBrandListController.formik.touched.DESCRICAO &&
								getProductBrandListController.formik.errors.DESCRICAO,
							'popup-form-inactive': !(
								getProductBrandListController.formik.touched.DESCRICAO &&
								getProductBrandListController.formik.errors.DESCRICAO
							),
						})}>
						{getProductBrandListController.formik.errors.DESCRICAO}
					</div>
				</div>
			</Dialog>

			<Dialog
				style={{ width: '450px' }}
				visible={getProductBrandListController.deleteDialog}
				onHide={handleProductBrandListController.closeDeleteDialog}
				footer={deleteProductBrandDialogFooter}
				header='Remover marca'
				modal>
				<div className='confirmation-content'>
					<i className='pi pi-exclamation-triangle p-mr-3' style={{ fontSize: '2rem' }} />
					{getProductBrandListController.selectedProductBrand && (
						<span>
							Você tem certeza que deseja deletar a marca{' '}
							<b>{getProductBrandListController.selectedProductBrand.DESCRICAO}</b>?
						</span>
					)}
				</div>
			</Dialog>
		</div>
	);
};

export default ProductBrandsList;
